export default "__VITE_ASSET__SOu8k2r$__"